<template lang="pug">
  .xs-f-small.max-at-tweak(@click="$emit('sectionLinkClick')")
    template(v-if='vueRoute')
      router-link.section-link( :to="url")
        span.icon-caret-left.color-slate.xs-f-medium.max-at-tweak(v-if="caretPosition == 'left'")
        span {{ linkText }}
        span.icon-caret-right.color-slate.xs-f-medium.max-at-tweak(v-if="caretPosition == 'right'")

    template(v-else)
      a.section-link(:href="url")
        span.icon-caret-left.color-slate.xs-f-medium.max-at-tweak(v-if="caretPosition == 'left'")
        span {{ linkText }}
        span.icon-caret-right.color-slate.xs-f-medium.max-at-tweak(v-if="caretPosition == 'right'")

</template>

<script>
  export default {
    name: "SectionLink",
    props: {
      url: {
        type: String,
        required: true
      },

      linkText: {
        type: String,
        required: true
      },

      vueRoute: {
        type: Boolean,
        required: false,
        default: true
      },

      caretPosition: {
        type: String,
        required: false,
        default: 'right'
      }
    }
   }
</script>

<style scoped lang="stylus">
  .section-link
    position relative
    display block
    padding 1.5em 5%
    margin 1em 0
    background-color color-white
    border-radius 8px
    border 1px solid color-fog-light


    &:after
      content ''
      clear both
      display table

  .section-link
    .icon-caret-right
      position absolute
      top 50%
      margin-top -0.75em
      right 0.5em

    .icon-caret-left
      margin-right .8em

  @media mq-mobile
    .section-link
      border-radius 0
      border-left none
      border-right none

  @media mq-mobile-tweak-upper
    .section-link
      border 1px solid color-fog-light
      border-radius 8px

</style>
